import Loader from "components/Loader/loader"
import React, { useState } from "react"
import { MdCancel } from "react-icons/md"
import { TiTick } from "react-icons/ti"
import { Modal, ModalHeader, ModalBody, Table, Input, Button } from "reactstrap"
import Swal from "sweetalert2"
import { FetchPutData } from "utils/Common_api_functions"

const formatTo12Hour = time => {
  if (!time) return ""

  const [hour, minute] = time.split(":")
  const date = new Date()
  date.setHours(hour, minute)

  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  })
}

const UnavailabilityModal = ({
  unavaliblityModal,
  setUnavaliblityModal,
  selectedEvent,
  getData,
}) => {
  const [loading, setloading] = useState(false)

  // Calculate total hours
  const calculateHours = (inTime, outTime) => {
    if (!inTime || !outTime) return 0
    const [inH, inM] = inTime.split(":").map(Number)
    const [outH, outM] = outTime.split(":").map(Number)
    let inDate = new Date(0, 0, 0, inH, inM)
    let outDate = new Date(0, 0, 0, outH, outM)
    if (outDate <= inDate) outDate.setDate(outDate.getDate() + 1)
    return ((outDate - inDate) / (1000 * 60 * 60)).toFixed(2)
  }

  const toggleUnavailable = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add unavaliablity for this employee?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIdata = await FetchPutData(
          setloading,
          `calendar/set/unavailability`,
          id
        )

        if (APIdata?.data?.success) {
          Swal.fire("Unavailability Added", APIdata?.data?.message, "success")
          getData()
          setUnavaliblityModal(false)
        } else {
          Swal.fire("Error!", APIdata?.response?.data?.message, "error")
        }
      }
    })
  }

  const handleApprove = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to approve this unavaliablity for employee?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, approve",
      cancelButtonText: "Cancel",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIdata = await FetchPutData(
          setloading,
          `calendar/unavailability/approval`,
          id,
          { unavailabilityStatus: true }
        )

        if (APIdata?.data?.success) {
          Swal.fire("Approved", APIdata?.data?.message, "success")
          getData()
          setUnavaliblityModal(false)
        } else {
          Swal.fire("Rejected!", APIdata?.response?.data?.message, "error")
        }
      }
    })
  }

  const handleReject = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to reject this unavaliablity for employee?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reject",
      cancelButtonText: "Cancel",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIdata = await FetchPutData(
          setloading,
          `calendar/unavailability/approval`,
          id,
          { unavailabilityStatus: false }
        )

        if (APIdata?.data?.success) {
          Swal.fire("Approved", APIdata?.data?.message, "success")
          getData()
          setUnavaliblityModal(false)
        } else {
          Swal.fire("Rejected!", APIdata?.response?.data?.message, "error")
        }
      }
    })
  }

  const filteredEmployees =
    selectedEvent?.employees?.filter(
      item => item?.status?.toLowerCase() !== "on holiday"
    ) || []

  return (
    <Modal
      isOpen={unavaliblityModal}
      toggle={() => setUnavaliblityModal(false)}
      size="lg"
      centered
    >
      {loading && <Loader />}
      <ModalHeader toggle={() => setUnavaliblityModal(false)}>
        Employee Unavailability
      </ModalHeader>
      <ModalBody>
        {filteredEmployees.length > 0 ? (
          <Table bordered>
            <thead className="bg-dark text-white">
              <tr>
                <th>Employee</th>
                <th>Location</th>
                <th>In Time</th>
                <th>Out Time</th>
                <th>Total Hrs</th>
                <th>Unavailable</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {filteredEmployees.map(emp => (
                <tr
                  key={emp.id}
                  className={
                    emp.status === "Unavailable" ? "bg-warning" : "bg-light"
                  }
                >
                  <td>{emp?.employee?.name}</td>
                  <td>{emp?.location?.name}</td>
                  <td>{formatTo12Hour(emp.inTime)}</td>
                  <td>{formatTo12Hour(emp.outTime)}</td>
                  <td>{calculateHours(emp.inTime, emp.outTime)}</td>

                  <td className="d-flex align-items-center gap-2">
                    <Input
                      type="checkbox"
                      checked={emp.status === "Unavailable"}
                      onChange={() => toggleUnavailable(emp.id)}
                      disabled={emp.status === "Unavailable"}
                    />

                    <span
                      className={`badge ${
                        emp.unavailabilityStatus === true
                          ? "bg-success"
                          : emp.unavailabilityStatus === false
                          ? "bg-danger"
                          : "bg-secondary"
                      }`}
                    >
                      {emp.unavailabilityStatus === true
                        ? "Approved"
                        : emp.unavailabilityStatus === false
                        ? "Rejected"
                        : "Pending"}
                    </span>
                  </td>

                  <td>
                    {emp.status === "Unavailable" && (
                      <>
                        <Button
                          color="success"
                          size="sm"
                          className="ms-2"
                          onClick={() => handleApprove(emp.id)}
                        >
                          <TiTick fontSize={16} />
                        </Button>
                        <Button
                          color="danger"
                          size="sm"
                          className="ms-1"
                          onClick={() => handleReject(emp.id)}
                        >
                          <MdCancel fontSize={16} />
                        </Button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <h4>No Employees Found for this JOB</h4>
        )}

        <div className="text-end mt-3">
          <Button color="primary" onClick={() => setUnavaliblityModal(false)}>
            Submit
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default UnavailabilityModal
